// extracted by mini-css-extract-plugin
export default {"sideMenu":"side-menu_sideMenu__BIH6y","sideMenuOpened":"side-menu_sideMenuOpened__dHiiL","closeButton":"side-menu_closeButton__jEew5"};